const { REACT_APP_SERVICE_BASE_URL_PRIVATE } = process.env;


export async function sendContactInfo(companyName, email, message, name) {

    const formattedMessage = `"SP-LABS" - ${message}`

    const response = await fetch(`${REACT_APP_SERVICE_BASE_URL_PRIVATE}/contact_form`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            company_name: companyName,
            email: email,
            message: formattedMessage,
            name: name
        })
    });
    const data = await response.json();
    return response.status;
}

export async function sendEbookContact(companyName, email, phone, name) {

    const formattedMessage = `"SP-LABS eBook" - ${phone}`

    const response = await fetch(`${REACT_APP_SERVICE_BASE_URL_PRIVATE}/contact_form`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            company_name: companyName,
            email: email,
            message: formattedMessage,
            name: name
        })
    });
    const data = await response.json();
    return response.status;
}